import { render, staticRenderFns } from "./editScript.vue?vue&type=template&id=4d16b9c7&scoped=true"
import script from "./editScript.vue?vue&type=script&lang=js"
export * from "./editScript.vue?vue&type=script&lang=js"
import style0 from "./editScript.vue?vue&type=style&index=0&id=4d16b9c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16b9c7",
  null
  
)

export default component.exports